import { useHistory } from "react-router-dom";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { AddPatientOnCaregiver } from "../../../features/caregiver/addPatientOnCaregiver.component";

export const PageCaregiverAddPatient = () => {
  const routeHistory = useHistory();
  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  routeHistory.length > 1
                    ? routeHistory.goBack()
                    : routeHistory.push(AppRouteUi.Root);
                }}
                className="pe-2 border-2 border-end click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <p className="text-capitalize mb-0 ps-2  text-green-200">
                Add New Patient (s)
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <AddPatientOnCaregiver />
    </Card>
  );
};
